import { publicEnv } from '@/config/runtime'
export const SUPPORT_EMAIL =
  publicEnv('VUE_APP_SUPPORT_EMAIL') || 'info@crypkit.com'
